"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
const Dropdown_1 = require("../Dropdown");
exports.DropdownContent = react_1.forwardRef((props, ref) => {
    const { isOpen } = react_1.useContext(Dropdown_1.DropdownContext);
    if (!isOpen) {
        return null;
    }
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, position: "absolute", background: "#fff", boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", borderRadius: "2px", width: "100%", zIndex: 10 }, props), void 0));
});
//# sourceMappingURL=index.js.map